<div class="wrapper" *ngIf="isLoggedIn$ | async">
  <!-- top navbar-->
  <app-header class="topnavbar-wrapper" *ngIf="isLoggedIn$ | async"></app-header>
  <!-- sidebar-->
  <app-sidebar class="aside-container" *ngIf="isLoggedIn$ | async"></app-sidebar>
  <!-- offsidebar-->
  <app-offsidebar class="offsidebar" *ngIf="isLoggedIn$ | async"></app-offsidebar>
  <!-- main section-->
  <section class="section-container" *ngIf="isLoggedIn$ | async">
    <!-- page content-->
    <div class="content-wrapper" *ngIf="isLoggedIn$ | async">
      <router-outlet></router-outlet>
    </div>
  </section>
</div>
<div class="wrapper" *ngIf="!(isLoggedIn$ | async)">
    <!-- page content-->
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
</div>
